/**
 * Charity search query helpers.
 *
 * The backend matches EINs as bare digits (e.g. 990903497), but EINs are
 * conventionally written and displayed with a dash (99-0903497). Users copy the
 * dashed form, which returns no results. Strip the punctuation before querying
 * when the term looks like an EIN, and leave name searches untouched.
 */

const EIN_PATTERN = /^\d{2}-?\d{7}$/

export function looksLikeEin(term) {
  return EIN_PATTERN.test((term ?? '').trim())
}

export function normalizeCharityQuery(term) {
  const trimmed = (term ?? '').trim()
  return looksLikeEin(trimmed) ? trimmed.replace(/\D/g, '') : trimmed
}

// For display formatting, use `formatEin` from lib/strings.js.
